var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 61,
    viewBox: "0 0 66 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8196 46.7467V29.7903L37.4063 23.9203L37.3756 29.7903L37.3673 31.3119V53.199V60.7318H38.268L43.8196 55.1802L66 33.0003L33.0003 0L0 33.0003L21.2792 54.2795L27.732 60.7318V52.2983V31.3119L27.7237 29.7903L27.693 23.9203L21.2792 29.7903V45.846L8.43344 33.0003L33.0003 8.43344L57.5666 33.0003L43.8196 46.7467Z",
    fill: "url(#paint0_linear_679_25210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_679_25210",
    x1: 33,
    y1: 0,
    x2: 33,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.1ae40029abf80496d89c8afa401ac300.svg";
export { ForwardRef as ReactComponent };